export default __webpack_public_path__ + "assets/img/LivenessGIF-2.bfe87730.gif";